module.exports = __webpack_public_path__ + "img/brand.388d3793.png";